import { useState } from 'react';
import { faqs } from '@/mocks/comics';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  return (
    <section className="relative w-full py-16 md:py-24 bg-background-50" id="faq">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-10">
        <div className="mb-2">
          <span className="text-xs font-medium text-foreground-500 uppercase tracking-widest">
            常见问题
          </span>
        </div>
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50">
            您可能想了解
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col gap-3">
            {faqs.map((faq, idx) => (
              <div
                key={idx}
                className="rounded-2xl bg-background-100/60 border border-background-200/40 overflow-hidden"
              >
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                >
                  <span className="text-sm md:text-base font-medium text-foreground-200 pr-4">
                    {faq.question}
                  </span>
                  <i
                    className={`ri-arrow-down-s-line text-lg text-foreground-500 flex-shrink-0 transition-transform duration-300 ${
                      openIdx === idx ? 'rotate-180' : ''
                    }`}
                  ></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openIdx === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm text-foreground-500 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqs.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}